<template>
    <with-data
        :debounce-ms="debounce"
        :dusk="id"
        :history="history"
        :query-string-defaults="defaultQuery"
        :query.sync="proxy"
        :source="getTableData"
        ref="withData"
    >
        <component
            :class="{
                'table-empty': !Number(result.total),
                'table-loading': isLoading,
                'table-loaded': isLoaded,
            }"
            :is="tag"
            class="jgile-table"
            slot-scope="{ result, isLoaded, isLoading, queryString }"
        >
            <slot
                :columns="tableColumns"
                :is-loaded="isLoaded"
                :is-loading="isLoading"
                :query="query"
                :query-string="queryString"
                :result="result"
                name="beforeGrid"
            ></slot>
            <slot :columns="tableColumns" :items="result.data" :meta="result.meta" :query="query" :response="result" name="items" v-if="result.total">
                <div :class="tableClass">
                    <template v-for="(item, item_key) in result.data">
                        <slot :columns="tableColumns" :item="item" :item-key="item_key" :query="query" name="item"></slot>
                    </template>
                </div>
            </slot>
            <template v-if="result.total === 0">
                <slot name="noResults">
                    <div>No Results</div>
                </slot>
            </template>
            <slot
                :columns="tableColumns"
                :is-loaded="isLoaded"
                :is-loading="isLoading"
                :query="query"
                :query-string="queryString"
                :result="result"
                name="afterGrid"
            ></slot>
            <div class="row" v-if="pagination">
                <div class="col">
                    <data-filter v-model="query.page">
                        <b-pagination
                            :hide-goto-end-buttons="true"
                            :per-page="Number(result.perPage)"
                            :total-rows="Number(result.total)"
                            :value="query.page"
                            @change="set"
                            size="md"
                            slot-scope="{ set }"
                        />
                    </data-filter>
                </div>
            </div>
        </component>
    </with-data>
</template>

<script>
import TableData from './TableData';
import GridMixins from '../mixins/grids';
import { PortalTarget } from 'portal-vue';

export default {
    mixins: [GridMixins],
    components: { PortalTarget, TableData },
    props: {
        id: {
            type: String,
            default: 'grid',
        },
        config: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            defaultConfig: {
                columns: [],
                tableClass: 'row',
            },
        };
    },
};
</script>
